// extracted by mini-css-extract-plugin
export var logo = "nav-module--logo--6e027";
export var nav = "nav-module--nav--b7415";
export var right = "nav-module--right--b7f39";